import { render } from "./BlockRoom.vue?vue&type=template&id=447e65c6&scoped=true"
import script from "./BlockRoom.vue?vue&type=script&lang=js"
export * from "./BlockRoom.vue?vue&type=script&lang=js"

import "./BlockRoom.vue?vue&type=style&index=0&id=447e65c6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-447e65c6"]])

export default __exports__